var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgM1(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 546,
    height: 1163,
    viewBox: "0 0 546 1163",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "m-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M290.665 1123.46C312.217 1088.91 337.053 1020.77 405.021 981.167C453.445 957.706 502.361 931.397 525.746 880.191C565.732 800.147 530.607 691.978 439.757 661.024C392.526 644.934 354.289 649.889 319.631 643.481C301.323 640.096 310.375 668.344 319.99 678.674C349.107 709.964 375.876 695.789 415.856 709.645C459.996 724.942 491.792 775.274 485.451 822.353C479.819 868.068 444.739 896.021 405.859 915.76C337.288 950.572 288.492 1002.11 248.507 1084.39C239.226 1095.95 230.19 1109.41 227.305 1124.31C221.902 1148.12 244.927 1169.89 266.732 1155.17C275.922 1148.95 281.681 1138.82 287.874 1129.64C292.286 1122.94 284.756 1128.99 290.619 1123.5L290.661 1123.46L290.665 1123.46Z",
    fill: "#DB9CF3",
    stroke: "#A7599C",
    strokeWidth: 6.05347,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M353.039 693.601C357.025 695.401 361.715 693.63 363.515 689.644C365.316 685.659 363.544 680.968 359.558 679.168C355.573 677.368 350.882 679.139 349.082 683.125C347.282 687.11 349.053 691.801 353.039 693.601Z",
    fill: "#E9BBF6",
    stroke: "#C684B9",
    strokeWidth: 2.01782,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M354.88 689.526C356.615 690.31 358.657 689.539 359.441 687.803C360.225 686.068 359.454 684.025 357.718 683.242C355.983 682.458 353.941 683.229 353.157 684.964C352.373 686.7 353.144 688.742 354.88 689.526Z",
    fill: "#E9BBF6",
    stroke: "#C684B9",
    strokeWidth: 2.01782,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M333.766 681.677C336.401 682.868 339.501 681.696 340.692 679.061C341.882 676.426 340.711 673.326 338.076 672.135C335.441 670.945 332.34 672.116 331.15 674.751C329.96 677.386 331.131 680.487 333.766 681.677Z",
    fill: "#E9BBF6",
    stroke: "#C684B9",
    strokeWidth: 2.01782,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M334.98 678.988C336.128 679.507 337.48 678.996 337.998 677.848C338.517 676.7 338.007 675.348 336.858 674.83C335.71 674.311 334.359 674.821 333.84 675.97C333.322 677.118 333.832 678.469 334.98 678.988Z",
    fill: "#E9BBF6",
    stroke: "#C684B9",
    strokeWidth: 2.01782,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M400.017 697.937C402.491 699.055 405.403 697.955 406.521 695.481C407.638 693.006 406.539 690.095 404.064 688.977C401.59 687.859 398.678 688.959 397.56 691.433C396.443 693.908 397.542 696.82 400.017 697.937Z",
    fill: "#E9BBF6",
    stroke: "#C684B9",
    strokeWidth: 2.01782,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M401.159 695.41C402.237 695.896 403.504 695.417 403.991 694.34C404.478 693.263 403.999 691.995 402.921 691.508C401.844 691.021 400.576 691.5 400.09 692.578C399.603 693.655 400.082 694.923 401.159 695.41Z",
    fill: "#E9BBF6",
    stroke: "#C684B9",
    strokeWidth: 2.01782,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M377.31 694.96C380.229 696.278 383.666 694.981 384.984 692.061C386.303 689.141 385.005 685.705 382.086 684.386C379.166 683.067 375.73 684.365 374.411 687.285C373.092 690.205 374.39 693.641 377.31 694.96Z",
    fill: "#E9BBF6",
    stroke: "#C684B9",
    strokeWidth: 2.01782,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M378.66 691.971C379.931 692.545 381.427 691.98 382.001 690.709C382.575 689.438 382.01 687.942 380.739 687.368C379.468 686.794 377.972 687.359 377.398 688.63C376.824 689.901 377.389 691.397 378.66 691.971Z",
    fill: "#E9BBF6",
    stroke: "#C684B9",
    strokeWidth: 2.01782,
    strokeMiterlimit: 10
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgM1);
export default __webpack_public_path__ + "static/media/m-1.805f3edd69820fc3561fb34389525d4c.svg";
export { ForwardRef as ReactComponent };